import { render, staticRenderFns } from "./JoinMiterIcon.vue?vue&type=template&id=08bf2b84&"
import script from "./JoinMiterIcon.vue?vue&type=script&lang=js&"
export * from "./JoinMiterIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports